module.exports = __webpack_public_path__ + "img/shcool_card_default.a675f03.jpg";